var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.loaded
    ? _c(
        "div",
        { staticClass: "t-hosted" },
        [
          _vm.title
            ? _c("vue-headful", { attrs: { title: _vm.title } })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "t-hosted__wrapper" }, [
            !_vm.$isMobile
              ? _c("div", { staticClass: "t-hosted__nav" }, [
                  _c("div", { staticClass: "t-nav" }, [
                    _c("div", { staticClass: "t-nav__header" }, [
                      _c("div", { staticClass: "t-nav__actions" }, [
                        _c(
                          "div",
                          { staticClass: "t-nav__action t-nav__logo" },
                          [
                            _vm.workspace.logo
                              ? _c("img", {
                                  attrs: {
                                    src: _vm.workspace.logo,
                                    height: "30px",
                                  },
                                })
                              : _vm.partnerMode
                              ? _c("img", {
                                  attrs: {
                                    src: require(`@/lib/assets/images/partner/${_vm.partnerId}/logo.svg`),
                                    height: "30px",
                                  },
                                })
                              : _c("img", {
                                  attrs: {
                                    src: require("@/lib/assets/images/trainn-logo-blue.svg"),
                                    height: "30px",
                                  },
                                }),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    !_vm.partnerMode &&
                    _vm.videoInfoLoaded &&
                    _vm.isFreemiumUser
                      ? _c("div", { staticClass: "t-nav__aside t-mar--t-lg" }, [
                          _c("div", { staticClass: "t-nav__actions" }, [
                            _vm.workspace.logo
                              ? _c(
                                  "div",
                                  { staticClass: "t-nav__action t-nav__logo" },
                                  [
                                    _vm.videoInfoLoaded && _vm.isFreemiumUser
                                      ? _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: "https://trainn.co/",
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: require("@/lib/assets/images/Trainn-Type-Assets/SVG/Trainn-type-original.svg"),
                                                height: "30px",
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._m(0),
                            _vm._v(" "),
                            _c("div", { staticClass: "t-nav__action" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "t-td--border",
                                  attrs: {
                                    href: "https://app.trainn.co/",
                                    target: "_blank",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("generic.link.go_to_app"))
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "t-hosted__content" }, [
              _vm.$isMobile
                ? _c("div", { staticClass: "t-hosted__header" }, [
                    _vm.workspace.logo
                      ? _c("img", {
                          attrs: { src: _vm.workspace.logo, height: "30px" },
                        })
                      : _c("img", {
                          attrs: {
                            src: require("@/lib/assets/images/trainn-logo-blue.svg"),
                            height: "30px",
                          },
                        }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "t-mar--b-xs t-flex t-flex--jcfe" }, [
                !_vm.partnerMode && _vm.videoInfoLoaded && _vm.isFreemiumUser
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "t-td--border t-tc--primary t-mar--l-st t-tw--nowrap",
                        attrs: { href: "https://trainn.co/", target: "_blank" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("generic.text.made_with")) +
                            "\n          "
                        ),
                        _c("img", {
                          attrs: {
                            src: require("@/lib/assets/images/trainn-logo-blue.svg"),
                            height: "14px",
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              !_vm.$isEmpty(_vm.videoList) &&
              !_vm.$isEmpty(_vm.videoList[_vm.currentIndex])
                ? _c(
                    "div",
                    {
                      key: "player",
                      staticClass: "t-vplayer t-mar--l-auto t-mar--r-auto",
                    },
                    [
                      !_vm.$isEmpty(
                        _vm.videoList[_vm.currentIndex].accessUrl
                      ) || _vm.videoList[_vm.currentIndex].deleted
                        ? _c(
                            "div",
                            { staticClass: "t-vplayer__main" },
                            [
                              !_vm.$isEmpty(
                                _vm.videoList[_vm.currentIndex].accessUrl
                              )
                                ? _c("video-player", {
                                    key: `video_${_vm.currentIndex}`,
                                    attrs: {
                                      video: _vm.videoList[_vm.currentIndex],
                                      poster:
                                        _vm.videoList[_vm.currentIndex].url,
                                    },
                                    on: {
                                      video_loaded: function ($event) {
                                        return _vm.startTracker(
                                          _vm.videoList[_vm.currentIndex]
                                        )
                                      },
                                    },
                                  })
                                : _vm.videoList[_vm.currentIndex].deleted
                                ? _c("video-not-available", {
                                    key: "video-not-found",
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "t-mar--t-st t-hosted__row t-flex--aib",
                                },
                                [
                                  _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "t-hosted__grow t-hosted__title t-mar--b-no",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.videoList[_vm.currentIndex]
                                              .title || "---"
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "t-vplayer__aside" },
                                    [
                                      _c(
                                        "t-button",
                                        {
                                          staticClass:
                                            "t-mar--r-sm t-mar--l-sm t-tc--muted",
                                          attrs: { variant: "action" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.satisfaction(
                                                _vm.videoList[_vm.currentIndex],
                                                "thumbs_up"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm.userFeedback &&
                                          _vm.userFeedback.satisfaction ==
                                            "thumbs_up"
                                            ? _c("i", {
                                                staticClass:
                                                  "t-tc--brand-primary mdi mdi-thumb-up mdi-32px",
                                              })
                                            : _c("i", {
                                                staticClass:
                                                  "mdi mdi-thumb-up-outline mdi-32px",
                                              }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.videoList[_vm.currentIndex]
                                .publishedVersion &&
                              _vm.videoList[_vm.currentIndex].publishedVersion
                                .description
                                ? _c("p", {
                                    staticClass:
                                      "t-hosted__description ProseMirror",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.videoList[_vm.currentIndex]
                                          .publishedVersion.description
                                      ),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.videoList[_vm.currentIndex].createdBy ||
                              _vm.videoList[_vm.currentIndex].createdAt
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "t-mar--t-md t-flex t-flex--aic t-fw--bold",
                                    },
                                    [
                                      _vm.videoList[_vm.currentIndex].createdBy
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "t-hosted__avatar t-hosted__avatar--md t-mar--r-mi",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.videoList[
                                                        _vm.currentIndex
                                                      ].createdBy.charAt(0)
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "t-hosted__details",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "t-fs--h5 t-mar--b-ti",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.videoList[
                                                            _vm.currentIndex
                                                          ].createdBy
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.videoList[_vm.currentIndex]
                                                  .createdAt
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "t-fs--caption",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(
                                                              _vm.$dateFromUTC(
                                                                _vm.videoList[
                                                                  _vm
                                                                    .currentIndex
                                                                ].createdAt
                                                              )
                                                            ) +
                                                            "\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm.videoInAccessible
                ? _c(
                    "div",
                    { staticClass: "t-vplayer t-mar--l-auto t-mar--r-auto" },
                    [
                      _c("video-not-available", {
                        attrs: { type: "link", code: _vm.errorCode },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _vm.videoInfoLoaded &&
          !_vm.$isEmpty(_vm.videoList) &&
          _vm.videoList.length > 1
            ? _c("div", { staticClass: "t-hosted__carousel" }, [
                _c(
                  "div",
                  { staticClass: "t-hosted__items" },
                  _vm._l(_vm.videoList, function (video, index) {
                    return _c(
                      "div",
                      {
                        key: video.id,
                        staticClass: "t-hosted__item",
                        class: {
                          "t-vplayer__card--active": index == _vm.currentIndex,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.setIndex(index)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "t-hosted__card" }, [
                          _c("img", {
                            staticClass: "t-hosted__image",
                            attrs: { src: video.url },
                          }),
                          _vm._v(" "),
                          _vm._m(1, true),
                          _vm._v(" "),
                          _c("div", { staticClass: "t-hosted__info" }, [
                            _c("h4", [_vm._v(_vm._s(video.title || "---"))]),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ],
        1
      )
    : _c("PageLoader", {
        key: "loader",
        staticClass: "t-mar--t-xxl t-flex--jcc",
      })
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "t-nav__action t-dis--blk" }, [
      _c("div", { staticClass: "t-nav__lists" }, [
        _c("div", { staticClass: "t-nav__list" }, [
          _c(
            "span",
            {
              staticClass: "t-mar--r-ti",
              staticStyle: {
                "font-family": "'Apple Color Emoji', 'Segoe UI Emoji',",
                "line-height": "1em",
                "white-space": "nowrap",
              },
              attrs: { role: "image", "aria-label": "✨" },
            },
            [_vm._v("✨")]
          ),
          _vm._v("Product-focussed Video\n                "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "t-nav__list" }, [
          _c(
            "span",
            {
              staticClass: "t-mar--r-ti",
              staticStyle: {
                "font-family": "'Apple Color Emoji', 'Segoe UI Emoji',",
                "line-height": "1em",
                "white-space": "nowrap",
              },
              attrs: { role: "image", "aria-label": "✨" },
            },
            [_vm._v("✨")]
          ),
          _vm._v("AI-enabled Voiceovers\n                "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "t-nav__list" }, [
          _c(
            "span",
            {
              staticClass: "t-mar--r-ti",
              staticStyle: {
                "font-family": "'Apple Color Emoji', 'Segoe UI Emoji',",
                "line-height": "1em",
                "white-space": "nowrap",
              },
              attrs: { role: "image", "aria-label": "✨" },
            },
            [_vm._v("✨")]
          ),
          _vm._v("Incredibly Shareable\n                "),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass:
            "t-button t-button--primary t-button--small t-button--fluid t-mar--t-xs",
          attrs: { href: "https://app.trainn.co/", target: "_blank" },
        },
        [_vm._v("Create Video")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "t-hosted__icon" }, [
      _c("i", { staticClass: "mdi mdi-motion-play" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }